import { useKeycloak } from "@react-keycloak/web";
import { Button, Form, Input, Space } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppSelector } from "../../../app/store";
import InfoIcon from "../../../assets/icons/InfoIcon";
import CustomModal from "../../../components/ui/CustomModal";
import Loader from "../../../components/ui/Loader";
import useError from "../../../hooks/useError";
import { useGetSingleBatchQuery } from "../batch/batchApi";
import { useGetSingleCompanyQuery } from "../companyOnboard/companyOnboardApi";
import {
  useOtpRequestTimeQuery,
  useReSendOtpMutation,
  useSendOtpMutation,
} from "./vendorPaymentApi";

type ApprovedModalProps = {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
  data?: any;
  paymentApi: (data: any) => void;
  isPaymentSuccess: boolean;
  isPaymentLoading: boolean;
  paymentMessage: string;
  batchId?: string | number;
};

const OTP_EXPIRY_SECONDS = 180;

const ApprovedModal = ({
  open,
  handleClose,
  refetch,
  data: pinVerifiedData,
  paymentApi,
  isPaymentSuccess,
  paymentMessage,
  isPaymentLoading,
  batchId,
}: ApprovedModalProps) => {
  const [remaining, setRemaining] = useState(OTP_EXPIRY_SECONDS);
  const [currentTime, setCurrentTime] = useState<string>(
    new Date().toISOString()
  );

  const { id } = useParams();
  const { keycloak } = useKeycloak();
  const token = keycloak?.token;
  const [sendOtp, { isError, error, isLoading, isSuccess, data }] =
    useSendOtpMutation();
  const [
    reSendOtp,
    {
      isError: reSendOtpIsError,
      error: reSendOtpError,
      isLoading: reSendOtpIsLoading,
      isSuccess: reSendOtpIsSuccess,
    },
  ] = useReSendOtpMutation();
  const {
    data: otpRequestTimeData,
    isError: otpRequestTimeIsError,
    error: otpRequestTimeError,
    refetch: otpRequestTimeRefatch,
  } = useOtpRequestTimeQuery(token);
  const { user } = useAppSelector((state) => state.auth);
  const {
    isLoading: isCompanyDetailsLoading,
    isError: isCompanyDetailsError,
    error: companyDetailsError,
    data: companyDetails,
  } = useGetSingleCompanyQuery(user?.data?.company_id, {
    skip: !user?.data?.company_id,
  });

  const {
    isError: singleBatchIsError,
    error: singleBatchError,
    data: singleBatchData,
  } = useGetSingleBatchQuery(batchId, {
    skip: !batchId,
  });

  //   const [
  //     vendorPaymentWithOtp,
  //     {
  //       isError: isVendorPaymentError,
  //       error: vendorPaymentError,
  //       isLoading: isVendorPaymentLoading,
  //       isSuccess: isVendorPaymentSuccess,
  //       data: vendorPaymentData,
  //     },
  //   ] = useVendorPaymentWithOtpMutation();
  useError(isError, error, "OTP send fail");
  //   useError(isVendorPaymentError, vendorPaymentError, "Vendor payment fail");
  useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");
  useError(
    otpRequestTimeIsError,
    otpRequestTimeError,
    "Get OTP request time fail"
  );
  useError(reSendOtpIsError, reSendOtpError, "OTP resend fail");
  useError(singleBatchIsError, singleBatchError, "Get single batch fail");

  let deviceId = localStorage.getItem("device_id");

  const handleApprover = (values: any) => {
    const newData = {
      ...values,
      pin: pinVerifiedData,
      sourceWallet: companyDetails?.data?.wallet_number, // old
      // sourceWallet: singleBatchData?.data?.wallet_number, // new
      App_Version: "4.1.0",
      Device_Id: deviceId,
      Device_Password: data?.data?.data?.Password,
      FullName: "SP1A.210812.016",
      LANG: "bn",
      Os_Version: "12",
      Phone_Brand: "itel S665L",
      Phone_Os: "android",
      Username: companyDetails?.data?.wallet_number, // old
      // Username: singleBatchData?.data?.wallet_number, // new
      companyId: user?.data?.company_id,
    };

    paymentApi({ id, data: newData });
    // vendorPaymentWithOtp({ id, data: newData });
  };

  useEffect(() => {
    if (paymentMessage && isPaymentSuccess) {
      toast.success(
        paymentMessage
        // vendorPaymentData?.message || "Payment approved successfully"
      );
      refetch();
      handleClose();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMessage, isPaymentSuccess]);

  useEffect(() => {
    if (companyDetails?.data?.wallet_number) {
      sendOtp({
        body: {
          Username: companyDetails?.data?.wallet_number, // old
          // Username: singleBatchData?.data?.wallet_number, // new
          FullName: "SP1A.210812.016",
          App_Version: "4.1.0",
          Phone_Brand: "itel S665L",
          Phone_Os: "android",
          Os_Version: "12",
          LANG: "bn",
          Device_Id: deviceId,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyDetails?.data?.wallet_number]);

  useEffect(() => {
    if (isSuccess) {
      toast.success("OTP send successfully");
      otpRequestTimeRefatch();
    }
  }, [isSuccess, otpRequestTimeRefatch]);

  useEffect(() => {
    const timer = setInterval(() => {
      // always store UTC string
      setCurrentTime(new Date().toISOString());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!isSuccess) {
      setRemaining(OTP_EXPIRY_SECONDS); // reset when not success
      return;
    }

    setRemaining(OTP_EXPIRY_SECONDS); // start from 3 min 00 sec
    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isSuccess]);

  useEffect(() => {
    if (!reSendOtpIsSuccess) {
      setRemaining(OTP_EXPIRY_SECONDS); // reset when not success
      return;
    }

    setRemaining(OTP_EXPIRY_SECONDS); // start from 3 min 00 sec
    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [reSendOtpIsSuccess]);

  // format mm:ss
  const minutes = String(Math.floor(remaining / 60)).padStart(2, "0");
  const seconds = String(remaining % 60).padStart(2, "0");

  const lastOtpTime = new Date(otpRequestTimeData?.data?.lastOtpRequestedAt);
  const expiryTime = new Date(lastOtpTime.getTime() + 3 * 60 * 1000);
  const newCurrentTime = new Date(currentTime);

  // difference in milliseconds
  const diffMs = expiryTime.getTime() - newCurrentTime.getTime();

  // convert to minutes & seconds
  const diffMinutes = Math.floor(diffMs / 1000 / 60);
  const diffSeconds = Math.floor((diffMs / 1000) % 60);

  const label = seconds === "00" ? `OTP` : `OTP ${minutes}:${seconds}`;

  // console.log(`Remaining: ${diffMinutes}m ${diffSeconds}s`);

  // console.log("expiryTime:", expiryTime);
  // console.log("Current time:", newCurrentTime);

  const handleResendOtp = () => {
    if (companyDetails?.data?.wallet_number) {
      reSendOtp({
        body: {
          // Username: companyDetails?.data?.wallet_number, // old
          // Username: singleBatchData?.data?.wallet_number, // new
          FullName: "SP1A.210812.016",
          App_Version: "4.1.0",
          Phone_Brand: "itel S665L",
          Phone_Os: "android",
          Os_Version: "12",
          LANG: "bn",
          Device_Id: deviceId,
        },
      });
    }
  };

  useEffect(() => {
    if (reSendOtpIsSuccess) {
      toast.success("OTP resend successfully");
      otpRequestTimeRefatch();
    }
  }, [reSendOtpIsSuccess, otpRequestTimeRefatch]);

  return (
    <CustomModal
      open={open}
      handleClose={() => {
        handleClose();
        refetch();
      }}
      width={400}
      footer={null}
    >
      <div className="flex items-center gap-2">
        <span className="bg-[#FFF6ED] p-1 rounded">
          <InfoIcon />
        </span>
        <span className="text-[22px] font-semibold">Approve</span>
      </div>
      {isLoading || isCompanyDetailsLoading ? (
        <Loader />
      ) : (
        <>
          <div className="my-2 mt-3 text-[#5E718D]">
            Are you sure you want to approve payment?
          </div>
          {minutes === "00" && seconds === "00" ? (
            <Space className="w-full mt-3" size={12}>
              <Button
                className="normal-dark-button modal-button"
                onClick={handleClose}
                size="middle"
              >
                Cancel
              </Button>

              <Button
                className="modal-button"
                type="primary"
                size="middle"
                onClick={handleResendOtp}
                loading={reSendOtpIsLoading}
              >
                Resend OTP
              </Button>
            </Space>
          ) : (
            <Form
              className="custom-form"
              requiredMark="optional"
              layout="vertical"
              onFinish={handleApprover}
            >
              <Form.Item
                label={
                  (isSuccess && remaining > 0) ||
                  (reSendOtpIsSuccess && remaining > 0) ? (
                    <span>{label}</span>
                  ) : null
                }
                name="OTP"
                rules={[
                  {
                    required: true,
                    message: "Please enter OTP",
                  },
                  {
                    pattern: /^\d{6,}$/,
                    message: "OTP must be at least 6 digits",
                  },
                ]}
              >
                <Input placeholder="Enter OTP" />
              </Form.Item>
              <Space className="w-full mt-3" size={12}>
                <Button
                  className="normal-dark-button modal-button"
                  onClick={handleClose}
                  size="middle"
                >
                  Cancel
                </Button>

                <Button
                  className="modal-button"
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={isPaymentLoading}
                >
                  Approve
                </Button>
              </Space>
            </Form>
          )}
        </>
      )}
    </CustomModal>
  );
};

export default ApprovedModal;
